import React, { useEffect, useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import Loader from "../utils/Loader";
import { userManualDownloadUrl, disclaimer } from "../utils/constants";
import useNotifications from "../hooks/useNotifications";
import NotificationPreviewModal from "./NotificationPreviewModal";
import NotificationDrawer from "./NotificationDrawer";
import NotificationMeta from "./NotificationMeta";
import NetworkStatusIndicator from "./NetworkStatusIndicator";
import HeaderInfoTiles, { readSessionList } from "./HeaderInfoTiles";
import MobileInfoPanel from "./MobileInfoPanel";

const ExhibitorHeader = () => {
  const navigate = useNavigate();
  const [isLoading, setLoader] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const { notifications, unreadCount, markAllRead, previewItem, openPreview, closePreview, showDrawer, openDrawer, closeDrawer } = useNotifications();
  const marqueeRef = useRef(null);
  const notificationRef = useRef(null);

  useEffect(() => { }, []);

  const onLogoutClick = () => {
    var code = sessionStorage.getItem('exhibitionCode')
    localStorage.clear();
    sessionStorage.clear();
    navigate(`/login/${code}`);
  };

  const loginData = JSON.parse(sessionStorage.getItem("loginDataSS") || "{}");
  const headerData = JSON.parse(
    sessionStorage.getItem("sessionHeaderData") || "[]"
  );

  const profileRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setShowProfile(false);
      }
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <>
      {isLoading && <Loader />}

      {isMobileMenuOpen && (
        <div
          className="mobile-menu-overlay exhibitor-mobile-overlay"
          onClick={closeMobileMenu}
        ></div>
      )}


      <div
        className={`mobile-sidebar-menu exhibitor-mobile-menu ${isMobileMenuOpen ? "mobile-menu-open" : ""
          }`}
      >
        <MobileInfoPanel
          name={loginData?.CompanyName || "Company Name"}
          onClose={closeMobileMenu}
          notifications={notifications}
          onNotificationClick={(n) => { openPreview(n.id); closeMobileMenu(); }}
          details={{
            dates: `${sessionStorage.getItem("ExhibitionFromDateSS") || ''} - ${sessionStorage.getItem("ExhibitionToDateSS") || ''}`,
            location: sessionStorage.getItem("ExhibitionAddressSS"),
            space: `${headerData?.[0]?.StallTypeName || "Stall Type"} / ${headerData?.[0]?.StallArea || "0"} sqm`,
          }}
          assistance={{ phones: readSessionList('sessionExhibitionMobileNo'), emails: readSessionList('sessionExhibitionEmail') }}
        />
        {/* Change Password and Logout live in the profile (user icon) menu only,
            so they aren't shown twice */}
      </div>

      <div className="app-header header sticky app-heder-with-logo pt-0 visitor-header-light">
        <div className="container-fluid main-container">
          <div className="d-flex align-items-center justify-content-between">
            {/* LOGO */}
            <div className="side-header d-flex align-items-center">
              <img
                src={sessionStorage.getItem("ExhibitionLogoSS")}
                alt="logo"
                style={{ width: '90px', height: 'auto', margin: '0 auto' }}
              />
            </div>

            {/* EXHIBITION INFO: plain text on tablets */}
            <h5 className="exbheader text-white d-none d-md-block d-xl-none">
              {sessionStorage.getItem("ExhibitionFromDateSS")} -{" "}
              {sessionStorage.getItem("ExhibitionToDateSS")} <br />
              {sessionStorage.getItem("ExhibitionAddressSS")}
            </h5>

            {/* Desktop: shared icon-tile details (header has no top padding, so start 8px down) */}
            <HeaderInfoTiles
              fromDate={sessionStorage.getItem("ExhibitionFromDateSS")}
              toDate={sessionStorage.getItem("ExhibitionToDateSS")}
              address={sessionStorage.getItem("ExhibitionAddressSS")}
              mobiles={readSessionList('sessionExhibitionMobileNo')}
              emails={readSessionList('sessionExhibitionEmail')}
              style={{ marginTop: 8 }}
            />

            {/* NOTIFICATION BELL + PROFILE ICON */}
            <div className="d-flex align-items-center gap-2 gap-md-3 exh-header-actions">
              {/* Network Connectivity */}
              <NetworkStatusIndicator />

              <div className="notification-bell-wrapper" ref={notificationRef}>
                <i
                  className="fa fa-bell fa-lg text-white"
                  onClick={() => { setShowNotifications(!showNotifications); setShowProfile(false); }}
                  style={{ cursor: 'pointer' }}
                ></i>
                {unreadCount > 0 && <span className="notification-badge">{unreadCount}</span>}
                {showNotifications && (
                  <div className="notification-dropdown shadow">
                    <div className="notification-dropdown-header">
                      <span>Notifications</span>
                      {unreadCount > 0 && <button className="mark-all-read-btn" onClick={markAllRead}>Mark all as read</button>}
                    </div>
                    {notifications.length === 0 ? (
                      <div className="notification-empty"><i className="fa fa-bell-slash-o"></i><br />No notifications</div>
                    ) : notifications.slice(0, 3).map(n => (
                      <div key={n.id} className={`notification-item${n.unread ? " unread" : ""}`}>
                        <span className={`notification-item-icon ${n.type}`}>
                          {n.initial}
                        </span>
                        <div className="notification-item-content">
                          <div className="notification-item-title" dangerouslySetInnerHTML={{ __html: n.title }}></div>
                          <NotificationMeta notification={n} />
                          {n.time && <div className="notification-item-time">{n.time}</div>}
                        </div>
                        <span className="notification-eye-btn" title="Preview" onClick={() => openPreview(n.id)}><i className="fa fa-eye"></i></span>
                      </div>
                    ))}
                    <div className="notification-dropdown-footer" style={{ cursor: 'pointer' }} onClick={openDrawer}>View all notifications</div>
                  </div>
                )}
              </div>

              {/* PROFILE ICON */}
              <div className="position-relative" ref={profileRef}>
                <span className="pd-trigger" onClick={() => setShowProfile(!showProfile)}>
                  <i className="fa fa-user-circle fa-2x text-white"></i>
                </span>

                {/* PROFILE DROPDOWN */}
                {showProfile && (
                  <div className="profile-dropdown pd-menu">
                    <div className="pd-head">
                      <span className="pd-head-icon"><i className="fa fa-building"></i></span>
                      <strong>{loginData?.CompanyName || "Company Name"}</strong>
                    </div>

                    <div className="pd-row pd-info">
                      <span className="pd-icon"><i className="fa fa-object-group"></i></span>
                      <span>{headerData?.[0]?.StallTypeName || "Stall Type"} / {headerData?.[0]?.StallArea || "0"} sqm</span>
                    </div>

                    <div className="pd-actions">
                      <Link to="/Change_Password" className="pd-row pd-link" onClick={() => setShowProfile(false)}>
                        <span className="pd-icon"><i className="fa fa-cog"></i></span>
                        <span>Change Password</span>
                      </Link>
                      <button type="button" className="pd-row pd-logout" onClick={onLogoutClick}>
                        <span className="pd-icon"><i className="fa fa-sign-out"></i></span>
                        <span>Logout</span>
                      </button>
                    </div>
                  </div>
                )}
              </div>
              
              {/* Mobile Toggle Button */}
              <div className="mobile-toggle exhibitor-mobile-toggle d-lg-none">
                <button
                  onClick={toggleMobileMenu}
                  className="exhibitor-menu-toggle-btn text-white" style={{ background: 'transparent', border: 'none', padding: '3px' }}>
                  <span className="exhibitor-menu-toggle-bar"></span>
                  <span className="exhibitor-menu-toggle-bar"></span>
                  <span className="exhibitor-menu-toggle-bar"></span>
                </button>
              </div>
            </div>{/* end bell+profile group */}
          </div>

          {/* DISCLAIMER */}
          <marquee
            style={{ fontSize: "15px", color: "#fff" }}
            behavior="scroll"
            direction="left"
            scrollamount="5"
            ref={marqueeRef}
            onMouseOver={() => marqueeRef.current?.stop()}
            onMouseOut={() => marqueeRef.current?.start()}
          >
            <b>Disclaimer:</b> {disclaimer}
          </marquee>
        </div>



      </div>
      <NotificationDrawer show={showDrawer} notifications={notifications} unreadCount={unreadCount} markAllRead={markAllRead} openPreview={openPreview} onClose={closeDrawer} />
      <NotificationPreviewModal notification={previewItem} onClose={closePreview} />
    </>
  );
};

export default ExhibitorHeader;
